export default __webpack_public_path__ + "assets/images/df7593f57dede45bf8f6d66ac45756fd.png";